<template>
  <VueHtml2pdf
    :enable-download="false"
    :show-layout="false"
    :float-layout="true"
    :preview-modal="true"
    :paginate-elements-by-height="1400"
    filename="manifest"
    :pdf-quality="2"
    :html-to-pdf-options="{
      // Attempts are improving the quality... Doesn't seem to make much difference
      image: {
        type: 'jpeg',
        quality: 1,
      },
      html2canvas: {
        dpi: 300,
        scale: 4,
        letterRendering: true,
        useCORS: true
      },
      margin: [30, 0],
    }"
    :ref="name"
  >
    <section slot="pdf-content" class="mx-5 my-4">
      <section class="pdf-item mb-3 text-left d-flex justify-content-between">
        <div class="text-sm">
          <img
                src="../assets/Marley_Logo.png"
                alt="boat Logo"
                style="flex: none;"
                height="128"
                width="128"
            />
          <div class="text-left">
            <!-- <div>
              Marley Shipping Inc.
            </div> -->
            <div>
              1234 Shipping Street
            </div>
            <div>
              Brooklyn, MY 11208
            </div>
            <div>
              Tel: 7186042692
            </div>
          </div>
        </div>
        <div style="width: 60%;">
          <table class="table table-bordered text-sm w-100">
            <tr>
              <td rowspan="3" colspan="2">
                <div class="text-xs font-weight-bold text-gray-500">Consignee</div>
                <div>
                  <div>
                    Marley Shipping Inc.
                  </div>
                  <div>
                    123 Shipping Street
                  </div>
                  <div>
                    Kingston 123
                  </div>
                </div>
              </td>
              <td colspan="2">
                <div class="text-xs font-weight-bold text-gray-500">
                  File
                </div>
                <div class="d-flex justify-content-between">
                  <span>635</span>
                  <span>JFK/KIN</span>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="text-xs font-weight-bold text-gray-500">
                  AWB/BL
                </div>
                <div>
                  SMLU 5985388A
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="text-xs font-weight-bold text-gray-500">
                  ETD
                </div>
                <div>
                  2/26/2020
                </div>
              </td>
              <td>
                <div class="text-xs font-weight-bold text-gray-500">
                  Flight/Vessel
                </div>
                <div>
                  Ocean Prom
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="text-xs font-weight-bold text-gray-500">
                  Pieces
                </div>
                <div>
                  157
                </div>
              </td>
              <td>
                <div class="text-xs font-weight-bold text-gray-500">
                  Gross Weight
                </div>
                <div>
                  32584 LBS
                </div>
              </td>
              <td colspan="2">
                <div class="text-xs font-weight-bold text-gray-500">
                  Carrier
                </div>
                <div>
                  Seaboard Marin
                </div>
              </td>
            </tr>
          </table>
        </div>
      </section>
      <section class="pdf-item mb-3 text-left">
        <table class="table text-sm w-100">
          <tr class="text-xs text-gray-700">
            <th>CL/BL Number</th>
            <th>Shipper</th>
            <th>Consignee</th>
            <th>Pcs/Weight</th>
            <th>Commodity</th>
          </tr>
          <tr>
            <td>9060</td>
            <td>
              <div>Karen Goffe - NY</div>
              <div>3320 Resevoir Oval East #48</div>
              <div>Bronx New York 10467</div>
              <div>1 347 465-0955</div>
            </td>
            <td>
              <div>Mark Goffe - KIN</div>
              <div>Lot 202 65 Place</div>
              <div>8th West Greater Porthmore</div>
              <div>St Catherine</div>
            </td>
            <td>
              <div>20/1235 L</div>
              <div>246.506</div>
              <div>CF</div>
            </td>
            <td>
              <div>ETA 2-22-20</div>
              <div></div>
              <div>1 Rolls 7x7x94 Rug</div>
              <div>1 Box 22x5x34 Computer Desk</div>
              <div>3 Pieces 22x22x46 Chair</div>
              <div>2 Box 28x22x42 Chairs</div>
              <div>1 Box 29x13x26 Computer Chair</div>
              <div>1 Pieces 44x18x10 Package Table</div>
              <div>1 Box 48x20x12 Chairs</div>
              <div>1 Pieces 68x5x43 Table</div>
            </td>
          </tr>
          <tr>
            <td>9061</td>
            <td>
              <div>Karen Goffe - NY</div>
              <div>3320 Resevoir Oval East #48</div>
              <div>Bronx New York 10467</div>
              <div>1 347 465-0955</div>
            </td>
            <td>
              <div>Mark Goffe - KIN</div>
              <div>Lot 202 65 Place</div>
              <div>8th West Greater Porthmore</div>
              <div>St Catherine</div>
            </td>
            <td>
              <div>20/1235 L</div>
              <div>246.506</div>
              <div>CF</div>
            </td>
            <td>
              <div>ETA 2-22-20</div>
              <div></div>
              <div>1 Rolls 7x7x94 Rug</div>
              <div>1 Box 22x5x34 Computer Desk</div>
              <div>3 Pieces 22x22x46 Chair</div>
              <div>2 Box 28x22x42 Chairs</div>
              <div>1 Box 29x13x26 Computer Chair</div>
              <div>1 Pieces 44x18x10 Package Table</div>
              <div>1 Box 48x20x12 Chairs</div>
              <div>1 Pieces 68x5x43 Table</div>
            </td>
          </tr>
        </table>
        <div class="font-weight-bold d-flex justify-content-between border-top">
          <span>Total</span>
          <span>
            157 PCS  32584 LBS
          </span>
        </div>
      </section>
    </section>
  </VueHtml2pdf>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';

export default {
  name: 'PrintManifest',
  props: [
    'name',
  ],
  data() {
    return {
      items: [],
    };
  },
  computed: {},
  components: {
    VueHtml2pdf,
  },
  methods: {
    generatePdf() {
      this.$refs[this.name].generatePdf();
    },
  },
  filters: {
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
};
</script>

<style scoped>
.table-bordered td, .table-bordered th {
  border: 1px solid #343434;
}
</style>
